import { Baseurl } from './url';

export const HANDS_ON_TIME_SOURCE_KEY = 'hands_on_time';

export const DEFAULT_THUMB = '/img/default-thumb.png';

// Badge icon for Hands-On Time clocks that don't have a photo yet.
export const HANDS_ON_TIME_ICON = 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50">' +
  '<circle cx="25" cy="25" r="22" fill="#e8720c" stroke="#ffffff" stroke-width="3"/>' +
  '<text x="25" y="33" font-size="24" text-anchor="middle" fill="#ffffff">&#9200;</text>' +
  '</svg>'
);

// The one image used for a place, on its map pin and in its info dialog:
// its own thumbnail when it has one, otherwise a placeholder (the clock icon
// for Hands-On Time, the default map icon for everything else).
export function getPlaceImage(thumb, sourceKey) {
  if (thumb) {
    // clocks added by users have their photo on the API itself, as a path
    const url = thumb.startsWith('/') ? `${Baseurl}${thumb}` : thumb;
    return { url, isPlaceholder: false };
  }
  const url = sourceKey === HANDS_ON_TIME_SOURCE_KEY ? HANDS_ON_TIME_ICON : DEFAULT_THUMB;
  return { url, isPlaceholder: true };
}
